module.exports = __webpack_public_path__ + "static/media/basic-profile-img.b6d02707.svg";